import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2024 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbIcon } from "abreact/misc/AbIcon";
import { AbSize, AbSizeContext } from "abreact/misc/AbSize";
import { AbWithTooltip } from "abreact/popup/AbWithTooltip";
import * as React from "react";
export const AbPseudoButton = props => {
  const contextSize = React.useContext(AbSizeContext);
  const size = props.size ?? contextSize ?? AbSize.MEDIUM;
  return /*#__PURE__*/React.createElement(AbWithTooltip, {
    tooltip: props.tooltip
  }, /*#__PURE__*/React.createElement("div", _extends({}, ReactUtils.componentProps("ab-pseudo-button", props, [size]), {
    "aria-label": props.ariaLabel,
    role: "button",
    onClick: e => {
      // This is meant for use only inside buttons, so it MUST block propagation and default.
      e.stopPropagation();
      e.preventDefault();
      props.onClick(e);
    }
  }), /*#__PURE__*/React.createElement(AbIcon, {
    image: props.icon,
    size: size
  })));
};
//# sourceMappingURL=AbPseudoButton.js.map
